/* eslint-disable react/function-component-definition */
import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../../PrivateRoute';
import PackageResultsPage from '../pages/PackageResultsPage/PackageResultsPage';
import PackageDetailsPage from '../pages/PackageDetailsPage/PackageDetailsPage';
import PackageBookingPage from '../pages/PackageBookingPage/PackageBookingPage';
import PackageBookingDetailsPage from '../pages/PackageBookingDetailsPage/PackageBookingDetailsPage';
import { PACKAGE_ROUTES } from '../constants/packageConstants';

/**
 * Self-contained route fragment for the holiday packages module.
 * Search itself lives on the landing page ("Packages" tab).
 *
 * Usage from /src/AppRoutes.jsx (same pattern as EsimRoutes):
 *   {appConfig?.hasPackage && PackageRoutes()}
 */
const PackageRoutes = () => (
  <>
    <Route
      path={PACKAGE_ROUTES.RESULTS}
      element={
        <PrivateRoute>
          <PackageResultsPage />
        </PrivateRoute>
      }
    />
    <Route
      path={PACKAGE_ROUTES.DETAILS}
      element={
        <PrivateRoute>
          <PackageDetailsPage />
        </PrivateRoute>
      }
    />
    <Route
      path={PACKAGE_ROUTES.BOOKING}
      element={
        <PrivateRoute>
          <PackageBookingPage />
        </PrivateRoute>
      }
    />
    <Route
      path={PACKAGE_ROUTES.BOOKING_DETAILS}
      element={
        <PrivateRoute>
          <PackageBookingDetailsPage />
        </PrivateRoute>
      }
    />
  </>
);

export default PackageRoutes;
